import { useEffect, useState } from 'react';
import { api } from '../api/client.js';

interface Log { id: number; event: string; target_type: string | null; target_id: string | null; created_at: string; ip_hash: string | null; metadata: Record<string, unknown> }

const LABELS: Record<string, string> = {
  'auth.login_success': '✅ Login',
  'auth.login_failed': '❌ Failed login',
  'auth.logout': '👋 Logout',
  'auth.mfa_enabled': '🟢 MFA enabled',
  'auth.mfa_disabled': '🔴 MFA disabled',
  'auth.email_verified': '✉️ Email verified',
  'auth.password_reset_used': '🔑 Password reset',
  'vault.item_created': '➕ Item created',
  'vault.item_updated': '✏️ Item updated',
  'vault.item_deleted': '🗑️ Item deleted',
  'vault.item_restored': '♻️ Item restored',
  'sharing.shared': '📤 Item shared',
  'sharing.revoked': '🚫 Share revoked',
};

export function AuditLogsPage() {
  const [logs, setLogs] = useState<Log[]>([]);
  useEffect(() => {
    (async () => {
      const res = await api.get<{ logs: Log[] }>('/audit-logs', { limit: '100' });
      setLogs(res.body.logs);
    })();
  }, []);

  return (
    <div className="panel">
      <p className="muted" style={{ fontSize: 13, marginTop: 0 }}>Append-only, sanitized event log. No secret values are ever recorded.</p>
      <table>
        <thead><tr><th>When</th><th>Event</th><th>Target</th></tr></thead>
        <tbody>
          {logs.map((l) => (
            <tr key={l.id}>
              <td className="muted mono" style={{ fontSize: 12 }}>{new Date(l.created_at).toLocaleString()}</td>
              <td>{LABELS[l.event] ?? l.event}</td>
              <td className="muted mono" style={{ fontSize: 12 }}>{l.target_type ? `${l.target_type}:${l.target_id?.slice(0, 8)}` : '—'}</td>
            </tr>
          ))}
          {logs.length === 0 && <tr><td colSpan={3} className="muted center">No events yet.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
